import React from "react";
import { Loader2, RefreshCw } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button } from "../ui/button";
import StakeholderLaneColumn from "./components/StakeholderLaneColumn";
import StakeholderOutreachQueue from "./components/StakeholderOutreachQueue";
import StakeholderSummaryStrip from "./components/StakeholderSummaryStrip";

export default function OperatingHome({
  board,
  fetchRemoteState,
  items,
  onOpenItem,
  onOpenTimeline,
  summary,
}) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top_left,_rgba(34,211,238,0.12),_transparent_24%),linear-gradient(180deg,#f8fafc_0%,#eef2f7_100%)] pb-10 dark:bg-[radial-gradient(circle_at_top_left,_rgba(34,211,238,0.09),_transparent_24%),linear-gradient(180deg,#05080d_0%,#0a1118_100%)]">
      <div className="mx-auto max-w-[1800px] px-4 py-6 sm:px-6 lg:px-8">
        <div className="rounded-[30px] border border-slate-200/80 bg-white/80 p-6 shadow-[0_35px_80px_-38px_rgba(15,23,42,0.45)] backdrop-blur dark:border-white/10 dark:bg-[#081018]/90">
          <div className="flex flex-col gap-5 border-b border-slate-200/80 pb-6 dark:border-white/10 lg:flex-row lg:items-end lg:justify-between">
            <div className="max-w-4xl">
              <p className="text-xs font-semibold uppercase tracking-[0.24em] text-cyan-700 dark:text-aqua">
                Community Home
              </p>
              <h1 className="mt-2 text-3xl font-semibold tracking-tight text-slate-950 dark:text-white">
                Run Dad Partners through the people it exists to serve.
              </h1>
              <p className="mt-3 max-w-3xl text-sm leading-6 text-slate-600 dark:text-slate-300">
                This board keeps names, movement, drift, and next moves in one place so the work does not
                disappear into polishing or memory.
              </p>
              {summary.loading ? (
                <div className="mt-4 inline-flex items-center gap-2 rounded-full border border-cyan-200 bg-cyan-50 px-3 py-1 text-xs font-medium text-cyan-800 dark:border-aqua/20 dark:bg-aqua/10 dark:text-aqua">
                  <Loader2 className="h-3.5 w-3.5 animate-spin" />
                  Refreshing live community data
                </div>
              ) : null}
            </div>

            <div className="flex items-center gap-3">
              <Button onClick={() => navigate("/community/weekly-report")} variant="outline">
                Open Weekly Report
              </Button>
              <Button onClick={fetchRemoteState} variant="outline">
                <RefreshCw className="mr-2 h-4 w-4" />
                Refresh
              </Button>
            </div>
          </div>

          <div className="mt-6">
            <StakeholderSummaryStrip summary={summary} />
          </div>

          <div className="mt-6">
            <StakeholderOutreachQueue
              fetchRemoteState={fetchRemoteState}
              items={items}
              onOpenItem={onOpenItem}
              onOpenTimeline={onOpenTimeline}
            />
          </div>

          <div className="mt-6 overflow-x-auto pb-2">
            <div className="flex min-w-max gap-4">
              {board.map((lane) => (
                <StakeholderLaneColumn
                  key={lane.id}
                  lane={lane}
                  onOpen={onOpenItem}
                  onOpenLane={(laneId) => navigate(`/community/lane/${laneId}`)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
